import { defineMessages } from 'react-intl';

export const scope = 'axionoee.features.machinesstatus.index';

export default defineMessages({
  machinesFilter: {
    id: `${scope}.grid.filters.machines`,
    defaultMessage: 'Machines',
  },
  fieldsToShow: {
    id: `${scope}.grid.fieldsToShow`,
    defaultMessage: 'Fields',
  },
  oee: {
    id: `${scope}.grid.fieldsToShow.oee`,
    defaultMessage: 'OEE',
  },
  a: {
    id: `${scope}.grid.fieldsToShow.a`,
    defaultMessage: 'A',
  },
  p: {
    id: `${scope}.grid.fieldsToShow.p`,
    defaultMessage: 'P',
  },
  q: {
    id: `${scope}.grid.fieldsToShow.q`,
    defaultMessage: 'Q',
  },
    currentShiftFilter: {
      id: `${scope}.grid.filters.currentShift`,
      defaultMessage: 'Current Shift',
    },
    prevShiftFilter: {
      id: `${scope}.grid.filters.prevShift`,
      defaultMessage: 'Prev.Shift',
    },
    dayFilter: {
      id: `${scope}.grid.filters.24h`,
      defaultMessage: '24h',
    },
    threeDayFilter: {
      id: `${scope}.grid.filters.72h`,
      defaultMessage: '72h',
    },
    filters: {
      id: `${scope}.grid.filters`,
      defaultMessage: 'Filters',
    },
    dontShowMachinesInNoOeeStop: {
      id: `${scope}.grid.filters.dontShowMachinesInNoOeeStop`,
      defaultMessage: "Don't show planned stops",
    },
    summary: {
      id: `${scope}.grid.summary`,
      defaultMessage: 'Summary',
    },
    oeeSummary: {
      id: `${scope}.grid.summary.oee`,
      defaultMessage: 'OEE',
    },
});
